import { DocChronologyEmptyStateIllustration } from '@/new/pages/matters/:matterId/subsets/:subsetId/chronologies/doc/components/doc-chronology-empty-state-illustration';

export function ProceduralTimelineEmptyState() {
  return (
    <div className="mt-32 flex flex-col items-center">
      <DocChronologyEmptyStateIllustration />

      <p className="font-serif text-2xl font-medium">Build your procedural timeline</p>

      <p className="mt-2 mb-8 max-w-xl text-center text-balance text-gray-500">
        Upload a court order, directions, or timetable and Wexler will automatically extract procedural events for your
        review. Events can also be added manually.
      </p>
    </div>
  );
}
